import computed from './computed'
import data from './data'
import methods from './methods'
import props from './props'
import validations from './validations'

export default {
  computed,
  data,
  methods,
  props,
  validations,

  resourcePath: '/v1/professional/schedules/'
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/components/transfer/resources/index.js